export default defineNuxtPlugin(() => {
  const route = useRoute()
  const managedClasses = Object.values(BodyClass)

  watch(
    () => route.meta.bodyClass,
    (bodyClass) => {
      document.body.classList.remove(...managedClasses)

      if (bodyClass) {
        document.body.classList.add(bodyClass)
      }
    },
    { immediate: true },
  )
})
